import { render, staticRenderFns } from "./LiveEvent.vue?vue&type=template&id=4363f04c"
import script from "./LiveEvent.vue?vue&type=script&lang=js"
export * from "./LiveEvent.vue?vue&type=script&lang=js"
import style0 from "./LiveEvent.vue?vue&type=style&index=0&id=4363f04c&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports